module.exports = __webpack_public_path__ + "img/isietuk.96290461.png";